<template>
  <div class="wrapper">
    <h2>
      Team Collaboration
      <el-button
        v-if="users.length > 0"
        type="primary"
        @click="invite = true"
      >
        New member
      </el-button>
    </h2>

    <div v-if="users.length === 0" class="align-center">
      <img src="../assets/hero/team.svg" class="nothing" />
      <h3>You can invite users to your project and define specific role.</h3>

      <el-button class="deploy" type="primary" @click="inviteUser">
        Invitation new member
      </el-button>
    </div>

    <template v-else>
      <el-table :data="teams" size="small">
        <el-table-column width="38px" />

        <el-table-column label="Team Member" width="300px">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              <strong>{{ scope.row.user.firstName }} {{ scope.row.user.lastName }}</strong>
              <el-tag v-if="scope.row.userEmail === user.email" type="primary" size="mini">You</el-tag>
            </div>
            {{ scope.row.userEmail }}
          </template>
        </el-table-column>

        <el-table-column label="Role">
          <template slot-scope="scope">
            <span v-if="permission('owner', scope.row.access) || permission('admin', scope.row.access)">
              Administrator <span v-if="permission('owner', scope.row.access)">(Owner)</span>
            </span>
            <span v-else-if="permission('manager', scope.row.access)">Manager</span>
            <span v-else-if="permission('developer', scope.row.access)">Developer</span>
            <span v-else-if="permission('accounting', scope.row.access)">Accounting</span>
          </template>
        </el-table-column>

        <el-table-column>
          <template v-if="scope.row.invite" slot-scope="scope">
            Invited by <strong>{{ scope.row.adminEmail }}</strong>
          </template>
        </el-table-column>

        <el-table-column width="350px" align="right">
          <template v-if="!permission('owner', scope.row.access) && scope.row.userEmail !== user.email && !scope.row.invite" slot-scope="scope">
            <template v-if="edit === scope.row.id">
              <el-select size="small" v-model="access">
                <el-option :value="2" label="Administrator" />
                <el-option :value="4" label="Manager" />
                <el-option :value="16" label="Developer" />
                <el-option :value="64" label="Accounting" />
              </el-select>

              <el-button
                size="mini"
                type="info"
                :loading="loading === scope.row.id"
                @click.prevent="save(scope.row)"
              >
                save
              </el-button>
            </template>

            <template v-else>
              <el-button
                size="small"
                icon="el-icon-edit"
                :loading="loading === scope.row.id"
                @click.prevent="edit = scope.row.id"
              >
                edit
              </el-button>

              <el-button
                size="small"
                :loading="loading === scope.row.id"
                @click.prevent="remove(scope.row)"
              >
                remove
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <TeamInvite :open.sync="invite" @change="$store.dispatch('getTeams')" />

    <el-dialog
      custom-class="request-upgrade-popup"
      title="Upgrade your account"
      :visible.sync="upgrade"
    >
      <BillingUpgrade
        :show-enterprise="false"
        request-access="team collaboration"
        @upgrade="inviteUser"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BillingUpgrade from '../components/Billing/Upgrade'
import TeamInvite from '../components/Team/Invite'

export default {
  components: {
    BillingUpgrade,
    TeamInvite
  },
  data () {
    return {
      access: 2,
      edit: null,
      invite: false,
      upgrade: false,
      loading: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    users () {
      return this.teams.filter((r) => r.userEmail !== this.user.email)
    },
    ...mapState(['teams', 'user', 'client']),
    ...mapGetters(['permission'])
  },
  methods: {
    inviteUser () {
      this.invite = !!this.client.team
      this.upgrade = !this.client.team
    },
    remove (role) {
      this.$confirm('This will remove this user from your team. Continue?', 'Warning', {
        confirmButtonText: 'Remove',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.loading = role.id
        return this.$store.dispatch(role.invite ? 'inviteCancel' : 'removeRole', role.id)
      })
    },
    save (role) {
      this.loading = role.id
      this.$store.dispatch('editRole', { ...role, access: this.access }).then(() => {
        this.loading = false
        this.edit = null
      })
    }
  },
  beforeMount () {
    if (!this.permission('owner') && !this.permission('admin')) {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  .nothing {
    max-height: 300px;
    padding: 50px 0 25px;
  }
  .el-tag {
    margin-left: 7px;
  }
  .el-select {
    margin-right: 15px;
  }
</style>

<style lang="scss">
  .request-upgrade-popup {
    width: calc(100% - 20px);
    max-width: 800px;

    .el-dialog__body {
      padding-top: 10px;
    }
    .el-dialog__header span {
      font-weight: bold;
      font-size: 20px;
    }
  }
</style>
